export default "__VITE_ASSET__ab9a5b4a__"